import styled from "styled-components";

const FullWidthImage = styled.img`
  height: 100%;
  width: 100%;
  object-fit: contain;
`;

export { FullWidthImage };
